import Text from '../../../../components/Text'
import anayaImgUrls from '../../../../constants/anaya-constants'
import ContactIcon from '../../../../assets/icons/contact-icon.png'
import HelpIcon from '../../../../assets/icons/help-icon.png'

const CareSpecialist = () => {
  const careSpecialistDetails = [
    {
      icon: ContactIcon,
      title: 'Who is a Care Specialist?',
      desc: 'A Care Specialist in Anaya Care Program is your compassionate guide, ready to listen, provide support, and help with any questions you may have.',
    },
    {
      icon: HelpIcon,
      title: 'How can I contact my Care Specialist?',
      desc: 'You can contact your Care Specialist through the Anaya Care app or by calling our helpline number.',
    },
  ]
  return (
    <section>
      <div className="px-5 pt-6 space-y-7">
        <Text
          tag="p"
          variant="headline"
          size="large"
          className="text-[#213053]"
        >
          Meet your Care Specialist
        </Text>

        <Text
          tag="p"
          variant="body"
          size="large"
          className="text-[#344054] opacity-[0.7]"
        >
          Your Care Specialist is always here for you, providing compassionate
          support and answers to your queries.
        </Text>

        <div>
          <img
            src={anayaImgUrls.careSpecialistBanner}
            alt="care-specialist-banner"
            className="w-full h-auto max-h-[310px] object-scale-down"
          />

          {/* Card Section */}
          <div className="px-1">
            <div className="space-y-8 p-4 border border-[#E4E7EC] rounded-lg relative -top-8 mb-6">
              {careSpecialistDetails.map((item) => (
                <div className="flex items-start gap-2" key={item.title}>
                  <img src={item.icon} alt="help-icon" className="w-6 h-6" />
                  <div className="space-y-1.5">
                    <Text
                      tag="p"
                      variant="title"
                      size="large"
                      className="text-[#1F2933]"
                    >
                      {item.title}
                    </Text>
                    <Text
                      tag="p"
                      variant="body"
                      size="large"
                      className="text-[#667085]"
                    >
                      {item.desc}
                    </Text>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CareSpecialist
